"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONTENT_FRONT_PAGE = void 0;
const CONTENT_FRONT_PAGE = exports.CONTENT_FRONT_PAGE = 'content-front-page';
